import { render, staticRenderFns } from "./CustomerStory.vue?vue&type=template&id=73ab2244&scoped=true&"
import script from "./CustomerStory.vue?vue&type=script&lang=js&"
export * from "./CustomerStory.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStory.vue?vue&type=style&index=0&id=73ab2244&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ab2244",
  null
  
)

export default component.exports